import SubCompanymain from "./SubCompanymain";

const allSiteSubcompanyRoutes = [
  {
    path: "setting",
    component: <SubCompanymain />,
  },
];

const SiteSubcompanyRoute = {
  path: "setting",
  component: <SubCompanymain />,
};

export default allSiteSubcompanyRoutes;

export { SiteSubcompanyRoute };
